import Footer from "./Footer";

export const FooterComponents = { Footer };
